import { useState } from 'react'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import MobileDatePicker from '@mui/lab/MobileDatePicker'
import PickersDay, { pickersDayClasses } from '@mui/lab/PickersDay'
import InputAdornment from '@mui/material/InputAdornment'
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'
import Typography from '@mui/material/Typography'
import AdxInput from './AdxInput'

const AdxPickerDay = (date, selectedDates, pickersDayProps) => {
  //ALL THE PROPS; date, selectedDates, pickersDayProps;
  //must be included in params above eventhough it is not called below.
  //Removing it will crash the calendar.
  return (
    <PickersDay
      {...pickersDayProps}
      sx={{
        [`&&.${pickersDayClasses.selected}`]: {
          backgroundColor: 'alternate.main',
          color: 'white.main',
          fontWeight: 'bold',
        },
        [`&&.${pickersDayClasses.root}`]: {
          fontSize: '14px',
          borderRadius: 2,
        },
        [`&&.${pickersDayClasses.today}`]: {
          borderWidth: '2px',
          borderColor: 'alternate.main',
        },
        [`&&.${pickersDayClasses.disabled}`]: {
          color: 'light-gray-text-2.main',
        },
      }}
    />
  )
}

const AdxDatePicker = ({
  errorMessage,
  isErrorShown,
  name,
  sx,
  sxLabel,
  blockFuture = false,
  ...rest
}) => {
  const [value, setValue] = useState(new Date())
  const handleChange = (newValue) => {
    setValue(newValue)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MobileDatePicker
        value={value}
        inputFormat="dd/MM/yyyy"
        onChange={handleChange}
        orientation="portrait"
        renderInput={(params) => (
          <AdxInput
            sx={{
              svg: { color: 'light-gray-text.main' },
              input: { color: 'dark-text.main', cursor: 'pointer' },
              ...sx,
            }}
            sxLabel={{ ...sxLabel }}
            endAdornment={
              <InputAdornment
                position="end"
                sx={{ position: 'absolute', right: 13, pointerEvents: 'none' }}
              >
                <InsertInvitationIcon />
              </InputAdornment>
            }
            errorMessage={errorMessage}
            isErrorShown={isErrorShown}
            {...params}
            name={name}
          />
        )}
        openPickerIcon={{ children: <InsertInvitationIcon /> }}
        renderDay={AdxPickerDay}
        DialogProps={{
          PaperProps: {
            sx: {
              borderRadius: '4.5px',
            },
          },
        }}
        showToolbar={false}
        disableCloseOnSelect={false}
        okText={null}
        cancelText={null}
        clearable
        clearText={
          <Typography variant="body1" color="alternate.main">
            Clear
          </Typography>
        }
        maxDate={blockFuture ? new Date() : null}
        {...rest}
      />
    </LocalizationProvider>
  )
}

export default AdxDatePicker
